import axios from 'axios';

export const GET_TYPES = 'cms/types';

export function getTypes() {
  return axios.get(GET_TYPES);
}
